import React from 'react'
import PropTypes from 'prop-types'
import './faq.css'

const FAQ = ({
  rootClassName = '',
}) => {
  return (
    <div className={`faq-accordion ${rootClassName}`}>
      {/* FAQ 1 */}
      <div
        data-role="accordion-container"
        className="faq-element1 accordion-element"
      >
        <div className="faq-details1">
          <span className="faq-text10">
            Was ist eine Social Media Recruiting Agentur?
          </span>
          <span data-role="accordion-content" className="faq-text11 faq-answer">
            <span>
              Eine Social Media Recruiting Agentur ist ein spezialisierter Dienstleister, der Unternehmen dabei unterstützt, qualifizierte Fachkräfte über soziale Netzwerke wie LinkedIn, Instagram, TikTok und Facebook zu gewinnen. Dabei werden zielgruppenspezifische Recruiting-Kampagnen entwickelt, die passive Kandidaten ansprechen und die Arbeitgebermarke stärken. Im Gegensatz zu traditionellen Stellenanzeigen ermöglicht Social Media Recruiting eine direkte und authentische Ansprache potenzieller Bewerber dort, wo sie ihre Zeit verbringen.
            </span>
          </span>
        </div>
        <div data-role="accordion-icon">
          <svg viewBox="0 0 1024 1024" className="faq-icon10" aria-hidden="true">
            <path d="M366 708l196-196-196-196 60-60 256 256-256 256z"></path>
          </svg>
        </div>
      </div>

      {/* FAQ 2 */}
      <div
        data-role="accordion-container"
        className="faq-element2 accordion-element"
      >
        <div className="faq-details2">
          <span className="faq-text12">
            Welche Vorteile bietet Social Media Recruiting?
          </span>
          <span data-role="accordion-content" className="faq-text13 faq-answer">
            <span>
              Social Media Recruiting bietet mehrere entscheidende Vorteile: <strong>1) Zugang zu passiven Kandidaten</strong> – 70% der Fachkräfte sind nicht aktiv auf Jobsuche, aber offen für neue Chancen. <strong>2) Gezielte Ansprache</strong> nach Qualifikationen, Interessen und Standort durch präzises Targeting. <strong>3) Stärkung der Arbeitgebermarke</strong> durch authentischen Content und Employer Branding. <strong>4) Messbare Ergebnisse</strong> und ROI-Tracking in Echtzeit. <strong>5) Schnellere Besetzungszeiten</strong> – durchschnittlich 40% kürzere Time-to-Hire im Vergleich zu klassischen Methoden.
            </span>
          </span>
        </div>
        <div data-role="accordion-icon">
          <svg viewBox="0 0 1024 1024" className="faq-icon12" aria-hidden="true">
            <path d="M366 708l196-196-196-196 60-60 256 256-256 256z"></path>
          </svg>
        </div>
      </div>

      {/* FAQ 3 */}
      <div
        data-role="accordion-container"
        className="faq-element3 accordion-element"
      >
        <div className="faq-details3">
          <span className="faq-text14">
            Was kostet eine Social Media Recruiting Agentur?
          </span>
          <span data-role="accordion-content" className="faq-text15 faq-answer">
            <span>
              Die Kosten einer Social Media Recruiting Agentur variieren je nach Leistungsumfang. Typische Preismodelle sind: <strong>Monatliche Retainer</strong> zwischen 2.000-10.000€ für kontinuierliche Betreuung, <strong>erfolgsbasierte Vermittlungsgebühren</strong> von 15-25% des Jahresgehalts, oder <strong>Kampagnen-Pakete</strong> ab 3.000€ für projektbezogene Recruiting-Maßnahmen. Eine seriöse Social Recruiting Agentur bietet transparente Preismodelle, messbare KPIs und regelmäßiges Reporting über den Kampagnenerfolg.
            </span>
          </span>
        </div>
        <div data-role="accordion-icon">
          <svg viewBox="0 0 1024 1024" className="faq-icon14" aria-hidden="true">
            <path d="M366 708l196-196-196-196 60-60 256 256-256 256z"></path>
          </svg>
        </div>
      </div>

      {/* FAQ 4 */}
      <div
        data-role="accordion-container"
        className="faq-element4 accordion-element"
      >
        <div className="faq-details4">
          <span className="faq-text16">
            Welche Social Media Plattformen sind für Recruiting am effektivsten?
          </span>
          <span data-role="accordion-content" className="faq-text17 faq-answer">
            <span>
              Die effektivsten Plattformen hängen von der Zielgruppe ab: <strong>LinkedIn</strong> eignet sich optimal für Fach- und Führungskräfte sowie B2B-Recruiting. <strong>Instagram</strong> erreicht jüngere Talente, kreative Berufe und eignet sich hervorragend für visuelles Employer Branding. <strong>TikTok</strong> ist ideal für Gen Z und Ausbildungsplätze mit authentischem Video-Content. <strong>Facebook</strong> funktioniert gut für regionale Stellen und gewerbliche Berufe. Eine professionelle Social Media Recruiting Agentur entwickelt kanalübergreifende Strategien, die mehrere Plattformen kombinieren.
            </span>
          </span>
        </div>
        <div data-role="accordion-icon">
          <svg viewBox="0 0 1024 1024" className="faq-icon16" aria-hidden="true">
            <path d="M366 708l196-196-196-196 60-60 256 256-256 256z"></path>
          </svg>
        </div>
      </div>

      {/* FAQ 5 */}
      <div
        data-role="accordion-container"
        className="faq-element5 accordion-element"
      >
        <div className="faq-details5">
          <span className="faq-text18">
            Wie lange dauert es, bis Social Media Recruiting Ergebnisse zeigt?
          </span>
          <span data-role="accordion-content" className="faq-text19 faq-answer">
            <span>
              Erste Ergebnisse im Social Media Recruiting zeigen sich typischerweise nach <strong>2-4 Wochen</strong>. In dieser Zeit werden Kampagnen aufgesetzt, optimiert und erste qualifizierte Bewerbungen generiert. Die <strong>Kampagnen-Optimierung</strong> erfolgt kontinuierlich über 8-12 Wochen, um die besten Ergebnisse zu erzielen. Für nachhaltigen Erfolg und eine starke Arbeitgebermarke empfehlen wir eine <strong>langfristige Zusammenarbeit</strong> von mindestens 6 Monaten mit einer Social Media Recruiting Agentur.
            </span>
          </span>
        </div>
        <div data-role="accordion-icon">
          <svg viewBox="0 0 1024 1024" className="faq-icon18" aria-hidden="true">
            <path d="M366 708l196-196-196-196 60-60 256 256-256 256z"></path>
          </svg>
        </div>
      </div>

      {/* FAQ 6 */}
      <div
        data-role="accordion-container"
        className="faq-element6 accordion-element"
      >
        <div className="faq-details6">
          <span className="faq-text20">
            Wie funktioniert Social Recruiting über LinkedIn?
          </span>
          <span data-role="accordion-content" className="faq-text21 faq-answer">
            <span>
              LinkedIn Recruiting umfasst mehrere Strategien: <strong>Active Sourcing</strong> durch direkte Kandidatenansprache und InMail-Kampagnen, <strong>LinkedIn Recruiter</strong> für erweiterte Suchfunktionen und Talentpool-Management, <strong>Sponsored Content</strong> für Reichweite und Employer Branding, <strong>Job Slots</strong> für prominente Stellenanzeigen und <strong>LinkedIn-Gruppen</strong> für Community-Building. Eine erfahrene Social Recruiting Agentur kombiniert diese Tools strategisch für maximale Wirkung und erreicht so auch passive Fach- und Führungskräfte.
            </span>
          </span>
        </div>
        <div data-role="accordion-icon">
          <svg viewBox="0 0 1024 1024" className="faq-icon20" aria-hidden="true">
            <path d="M366 708l196-196-196-196 60-60 256 256-256 256z"></path>
          </svg>
        </div>
      </div>

      {/* FAQ 7 */}
      <div
        data-role="accordion-container"
        className="faq-element7 accordion-element"
      >
        <div className="faq-details7">
          <span className="faq-text22">
            Ist Social Media Recruiting auch für den Mittelstand geeignet?
          </span>
          <span data-role="accordion-content" className="faq-text23 faq-answer">
            <span>
              Ja, Social Media Recruiting ist <strong>besonders für den Mittelstand</strong> geeignet. Mit gezieltem Targeting können auch kleinere Budgets effektiv eingesetzt werden – Streuverluste werden minimiert. Mittelständische Unternehmen können ihre Stärken wie <strong>flache Hierarchien</strong>, vielfältige Aufgaben und <strong>familiäre Unternehmenskultur</strong> authentisch kommunizieren und sich so von Großkonzernen abheben. Eine Social Recruiting Agentur hilft, die individuellen Vorteile als Arbeitgeber herauszuarbeiten und die passende Zielgruppe anzusprechen.
            </span>
          </span>
        </div>
        <div data-role="accordion-icon">
          <svg viewBox="0 0 1024 1024" className="faq-icon22" aria-hidden="true">
            <path d="M366 708l196-196-196-196 60-60 256 256-256 256z"></path>
          </svg>
        </div>
      </div>

      {/* FAQ 8 */}
      <div
        data-role="accordion-container"
        className="faq-element8 accordion-element"
      >
        <div className="faq-details8">
          <span className="faq-text24">
            Wie erreiche ich passive Kandidaten über Social Media?
          </span>
          <span data-role="accordion-content" className="faq-text25 faq-answer">
            <span>
              Passive Kandidaten – Fachkräfte, die nicht aktiv suchen, aber offen für neue Chancen sind – werden durch <strong>gezieltes Targeting</strong> auf Social Media erreicht. Entscheidend sind: <strong>Interessenbasiertes Targeting</strong> nach beruflichen Qualifikationen und Skills, <strong>Lookalike-Audiences</strong> basierend auf Ihren besten Mitarbeitern, <strong>authentischer Employer Branding Content</strong>, der die Unternehmenskultur zeigt, und <strong>Active Sourcing</strong> durch direkte, personalisierte Ansprache. Eine Social Recruiting Agentur kombiniert diese Maßnahmen strategisch.
            </span>
          </span>
        </div>
        <div data-role="accordion-icon">
          <svg viewBox="0 0 1024 1024" className="faq-icon24" aria-hidden="true">
            <path d="M366 708l196-196-196-196 60-60 256 256-256 256z"></path>
          </svg>
        </div>
      </div>
    </div>
  )
}

FAQ.propTypes = {
  rootClassName: PropTypes.string,
}

export default FAQ
